var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badgesList"},[_vm._m(0),_c('div',{staticClass:"badges"},[(_vm.showPremiumBadge)?_c('Badge',{attrs:{"badge":_vm.getPremiumBadge}}):_vm._e(),_vm._l((_vm.getBadgesToDisplay),function(badge,x){return _c('Badge',{key:x,attrs:{"badge":badge}})})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('h1',{staticClass:"title"},[_vm._v("Badges")])])
}]

export { render, staticRenderFns }